import { createSelector } from '@reduxjs/toolkit';
import { State } from 'app/store';

export const selectPackages = (state: State) => state.packages.packages;

export const selectPackagesList = createSelector([selectPackages], (packages) => Object.values(packages));

const selectSelectedPackageId = (state: State) => state.packages.selectedIndex;
export const selectOwnedPackage = (state: State) => state.packages.ownedPackage;

export const selectOwnedNftId = (state: State) => state.packages.ownedNftId;

export const selectIsOwnedPackage = (state: State) => state.packages.ownedPackage !== null;

export const selectCurrentPackage = createSelector(
  [selectPackagesList, selectSelectedPackageId],
  (packages, selectedId) => {
    const selectedPackage = packages[selectedId];
    return { ...selectedPackage, id: selectedId };
  },
);
